// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__3GHxo","Logo":"Toolbar_Logo__1CgVs"};